import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import { assets } from "../assets/assets";
import './conserto_relogio.css'; // Reutilizando o CSS para manter o padrão visual
import { abrirOrcamentoWhats, trazerRodapePaginasServicos, trazerTituloServicos } from '../utils/utils';

const ServicosEletronicos = () => {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Serviços em eletrônicos";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />

      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.servicosEletronicos})` }}>
        <div className="servico-hero-overlay">
          <h1>Serviços em Eletrônicos</h1>
          <p>Sempre ligado ao que importa.</p>
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloServicos('eletrônicos')}</h2>
        </article>

        {/* Bloco 1: Conserto de Controles Remotos */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Controles remotos</h3>

            <h4>Botões</h4>
            <p>Correção dos botões para resposta aos comandos.</p>

            <h4>Limpeza técnica</h4>
            <p>Remoção de sujeira e oxidação para manter o funcionamento.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.consertoControles} alt="Conserto de controles remotos" />
          </div>
        </section>

        {/* Bloco 2: Conserto de Calculadoras */}
        <section className="sessao-explicativa reverse">
          <div className="texto-lado">
            <h3>Calculadoras</h3>

            <h4>Teclas</h4>
            <p>Ajuste das teclas para uso correto.</p>

            <h4>Limpeza técnica</h4>
            <p>Remoção de sujeira e oxidação para manter o funcionamento.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.consertoCalculadoras} alt="Conserto de calculadoras" />
          </div>
        </section>

        {/* Bloco 3: Outros Pequenos Eletrônicos */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Outros Eletrônicos</h3>

            <h4>Funcionamento</h4>
            <p>Correção de falhas para uso no dia a dia.</p>

            <h4>Limpeza técnica</h4>
            <p>Remoção de sujeira e oxidação para manter o funcionamento.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.consertoOutrosEletronicos} alt="Conserto de outros pequenos eletrônicos" />
          </div>
        </section>

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasServicos('serviços eletrônicos')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('serviços em eletrônicos')}>
            Solicitar orçamento
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default ServicosEletronicos;